'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _browser = require('@beastshop/browser');

var _bridge = require('@beastshop/bridge');

var _bridge2 = _interopRequireDefault(_bridge);

var _axios = require('@beastshop/axios');

var _axios2 = _interopRequireDefault(_axios);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function axios_mock(options) {
  if ((0, _browser.app)() && !options.jumpApp) {
    if (!options.headers) {
      options.headers = {};
    }

    Object.assign(options.headers, {
      'BeastH5': "1"
    });

    console.log(options, 'opts');

    return _bridge2.default.ajax(options);
  } else {
    if (!options.headers) {
      options.headers = {};
    }

    var _headers = {
      'TBS-Client': 3,
      'TBS-Channel': 'CHN2077',
      'Platform': (0, _browser.ios)() ? 'ios' : 'android',
      'BeastH5': 1
    };
    var ac = _jsCookie2.default.get('ac');
    if (ac) {
      _headers['TBS-USource'] = ac;
    }
    Object.assign(options.headers, _headers);
    return (0, _axios2.default)(options);
  }
}

exports.default = axios_mock;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/axios-m/lib/index.js
// module id = 65
// module chunks = 0